import { z } from "zod";

const preparationEvents = [
	"Cloned",
	"Cubed",
	"CubingFailed",
	"Dimensioned",
	"DimensioningFailed",
	"Failed",
	"ImportFailed",
	"ImportIgnored",
	"ImportStartFailed",
	"ImportStarted",
	"Imported",
	"Importing",
	"Importing",
	"ImportingFailed",
	"QuantityAdjusted",
	"Staged",
	"StagedFailed",
	"StagingFailed",
] as const;

const productionEvents = [
	"Cancelled",
	"Closed",
	"ClosedManually",
	"Closing",
	"ClosingExpired",
	"ClosingFailed",
	"ClosingRequired",
	"ClosingRemoved",
	"Completed",
	"HiddenFromSearch",
	"NoWorkSelected",
	"Produced",
	"Removed",
	"Reproduced",
	"Retracted",
	"Selected",
	"SelectionExpired",
] as const;

export const auditEventPreparationTypeSchema = z.enum(preparationEvents);
export const auditEventTypeSchema = z.enum([...preparationEvents, ...productionEvents]);

export type AuditEventType = z.infer<typeof auditEventTypeSchema>;
export type AuditEventPreparationType = z.infer<typeof auditEventPreparationTypeSchema>;
